module.exports = __webpack_public_path__ + "static/media/purple_pin.848e1d72.svg";